export default {
    BRANCA: 1,
    NEGRA: 2,
    AMARELA: 3,
    PARDA: 4,
    INDIGENA: 5,
    SEM_INFORMACAO: 6
}